/**
 * DOVE-2669 — a home location's unit belongs to the location itself. The API resolves it as
 * `unit_display` (the location's own unit plus any address line 2) and `resolved_unit` (the unit on its
 * own). The raw `unit` / `address_2` fields belong to an addresses row that other locations at the same
 * street share, so they can still hold an old unit. Blank values and the legacy "0" placeholder are
 * dropped everywhere.
 */
export function cleanUnit(value?: string | null): string {
	const trimmed = (value ?? '').trim();
	return trimmed === '0' ? '' : trimmed;
}
